export default {"src":"/_next/static/image/components/ui/Icon/icons/arrow-profile.02fe1fdba56b588de326c625824596fa.svg","height":7,"width":10};